import { Config } from 'src/types';

import { commonInitialization } from './commonInitialization';
import { renderMain } from './renderMain';
import { renderOnDomReady } from './renderOnDomReady';

export async function initializeApp(config: Config) {
  commonInitialization(config);
  renderOnDomReady(renderMain);
}
